import { useEffect, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'react-bootstrap';
import ContentLoader from 'react-content-loader';
import { InternalNavigation } from '@mdc/services';
import { InternalLink } from '@mdc/ui';

import './ThankYou.scss';


const ThankYou = ({ user, className, subscriptions, transactionId, addPageRouteChange }) => {
    const { t, ready } = useTranslation();
    const [userData, setUserData] = useState([]);

    const numberWithComma = (number) => {
        return number.toLocaleString();
    };

    if (!ready) {
        return;
    }

    useEffect(() => {
        addPageRouteChange(subscriptions);
    }, [transactionId, subscriptions]);

    useEffect(() => {
        if (user && (!userData || userData !== user)) {
            setUserData(user);
        }
    }, [user]);

    const userLicenses = useMemo(() => {
        if (!userData && (subscriptions && subscriptions[0]?.receiptUrl === null)) {
            return;
        }

        // eslint-disable-next-line camelcase
        const purchaseInformation = subscriptions || userData?.license?.purchase_information;

        return purchaseInformation?.map((plan) => {
            const { tier, type } = plan;
            return { tier, type };
        });
    }, [userData, subscriptions]);

    const userLicensesDom = useMemo(() => {
        const PLAN_NAMES = {
            'prevention': t('Prevention API'),
            'reputation': t('Reputation API'),
            'analysis': t('Analysis API')
        };

        if (!userLicenses) {
            return <div className='storeProductPlaceholder'>
                <ContentLoader
                    height={6}
                    width={40}
                    speed={1}
                    primaryColor="#EDEEF3"
                    secondaryColor="#f3f3f3"
                >
                    <rect x="0" y="0" rx="1" ry="1" width="270" height="10"/>
                </ContentLoader>
            </div>;
        }

        return userLicenses.map((license, index) => {
            const planTier = license?.tier?.split(' ')[1];
            const planName = license?.tier?.split(' ')[0];

            return <li
                key={index}
                className='planPrice'
            >
                <span className="planLimit">{PLAN_NAMES[planName]}</span>
                <div className="float-right">
                    {t('Daily limit:')}{' '}
                    <span className="pricingPlanPrice">{ numberWithComma(planTier) }</span>
                </div>
            </li>;
        });
    }, [userLicenses]);

    if (typeof userData === 'undefined') {
        InternalNavigation.navigation('/store');
    }

    return <section className='thankYouWrapper'>
        <Row className={className}>
            <Col xs={12} className='text-center'>
                <span className="apiSymbol d-block">
                    <i className="icon-cart"></i>
                </span>
                <h1>{t('Thank you for purchasing from our online store! Your license now includes:')}</h1>
            </Col>
            <Col xs={{ span: 10, offset: 1 }} sm={{ span: 6, offset: 3 }} md={{ span: 4, offset: 4 }} className="text-center">
                <div>
                    {userLicensesDom}
                </div>
            </Col>
        </Row>
        <Row className='text-center'>
            <Col>
                <InternalLink url="/account" className="btn btn-primary" type="button" text={t('MY ACCOUNT')}/>
            </Col>
        </Row>
    </section>;
};

ThankYou.propTypes = {
    user: PropTypes.any,
    className: PropTypes.string,
    subscriptions: PropTypes.array,
    transactionId: PropTypes.string,
    addPageRouteChange: PropTypes.func
};

export default ThankYou;
